"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryEInstantsGroupedList = void 0;
class HistoryEInstantsGroupedList extends Array {
    constructor() {
        super(...arguments);
        this.getTransactionDateSorted = () => {
            const einstantsList = new HistoryEInstantsGroupedList();
            if (this.length > 0) {
                this.sort((x, y) => {
                    const transactionDateX = !!x.transactionDate ? x.transactionDate : 0;
                    const transactionDateY = !!y.transactionDate ? y.transactionDate : 0;
                    return transactionDateX > transactionDateY ? -1 : 1;
                }).forEach(x => {
                    einstantsList.push(x);
                });
            }
            return einstantsList;
        };
    }
}
exports.HistoryEInstantsGroupedList = HistoryEInstantsGroupedList;
//# sourceMappingURL=HistoryEInstantsGroupedList.js.map